<app-status-sidebar
  [itemId]="revisionId()"
  [config]="revisionConfig"
  [service]="revisionService"
  [updateMethod]="'updateRevision'"
  [getDetailsMethod]="'getSingleRevision'"
></app-status-sidebar>
